import { render, staticRenderFns } from "./minimal.vue?vue&type=template&id=b72daed8&"
import script from "./minimal.vue?vue&type=script&lang=js&"
export * from "./minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loader: require('/opt/build/repo/components/global/Loader.vue').default,DisplayErrors: require('/opt/build/repo/components/global/DisplayErrors.vue').default})
